import { useReadContract } from "wagmi";
import useDappChain from "./useDappChain";
import useDappConfig from "./useDappConfig";
import { formatUnits } from "viem";
import { useSelector } from "react-redux";
import { ETH } from "@config/contractsConfig";
import useBufferPool from "./useBufferPool";

const useUnstakeInfo = () => {
  const { chain, isEthereumChain } = useDappChain();
  const { config, isRestakeSupported } = useDappConfig();
  const { selectedERC20 } = useSelector((state: any) => state.user);
  const { bufferPool } = useBufferPool();

  const assetToWithdrawInto =
    selectedERC20 !== ETH ? config.tokens[selectedERC20] : config.nativeToken;

  const { data: withdrawalableAmount } = useReadContract({
    ...config.interactionPools.lrtWithdrawalManager,
    functionName: "getAvailableAssetAmount",
    args: [assetToWithdrawInto?.address],
    query: {
      enabled:
        chain && isRestakeSupported && isEthereumChain && !!assetToWithdrawInto,
    },
  });

  const { data: minAmountToWithdraw } = useReadContract({
    ...config.interactionPools.lrtWithdrawalManager,
    functionName: "minRsEthAmountToWithdraw",
    args: [assetToWithdrawInto?.address],
    query: {
      enabled:
        chain && isRestakeSupported && isEthereumChain && !!assetToWithdrawInto,
    },
  });

  return withdrawalableAmount &&
    (selectedERC20 !== ETH ? minAmountToWithdraw : true)
    ? {
        withdrawalableAmount: formatUnits(withdrawalableAmount as bigint, 18),
        minAmountToWithdraw: formatUnits(minAmountToWithdraw as bigint, 18),
        bufferPoolForAsset: bufferPool[assetToWithdrawInto.symbol],
      }
    : {
        withdrawalableAmount: "0",
        minAmountToWithdraw: "0",
        bufferPoolForAsset: assetToWithdrawInto
          ? bufferPool[assetToWithdrawInto.symbol]
          : 0,
      };
};

export default useUnstakeInfo;
